// src/lib/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react'
import { supabase } from './supabase'

const AuthContext = createContext({})

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [tier, setTier] = useState('free')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Check active session on mount
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null)
      if (session?.user) fetchTier(session.user.id)
      setLoading(false)
    })

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setUser(session?.user ?? null)
        if (session?.user) fetchTier(session.user.id)
        else setTier('free')
      }
    )
    return () => subscription.unsubscribe()
  }, [])

  const fetchTier = async (userId) => {
    const { data } = await supabase
      .from('subscriptions')
      .select('tier')
      .eq('user_id', userId)
      .maybeSingle()
    setTier(data?.tier || 'free')
  }

  const value = {
    user,
    tier,
    isPro: tier === 'pro' || tier === 'elite',
    isElite: tier === 'elite',
    loading
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export const useAuth = () => useContext(AuthContext)
